import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $ from "jquery";
import {FormattedMessage} from "react-intl";

import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import Analytics from "../../../../analytics";
import {getCurrentLayout} from "../../../appLayout";

export default class MobileMenuSelect extends Component {

  static propTypes = {
    // relatedItems: PropTypes.array,
    // relatedItemClick: PropTypes.func.isRequired,
    onSubPartClick: PropTypes.func.isRequired,
    onParentItemClick: PropTypes.func.isRequired,
    parentItems: PropTypes.arrayOf(PropTypes.instanceOf(DesignNavigationItem)),
    activePart: PropTypes.object,
    activeSubPart: PropTypes.object,
    desktop: PropTypes.bool,
  };

  static defaultProps = {
    desktop: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      toggle: false,
      showRelatedItems: true,
      translateId: this.props.activeSubPart ? this.props.activeSubPart.translateId : ''
    };
  }

  componentDidMount() {
    if (!this.props.desktop) {
      this.setShowName(this.props);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleWrapperBlur)
  }

  componentWillReceiveProps(nextProps) {
    this.setShowName(nextProps);
  }

  setShowName(props) {
    if (props.activeSubPart && (props.activeSubPart.translateId !== this.state.translateId)) {
      this.setState({
        translateId: props.activeSubPart.translateId
      })
    }
    if (!props.activeSubPart && props.activePart && (props.activePart.partName !== this.state.translateId)) {
      this.setState({
        translateId: props.activePart.translateId
      })
    }
  }

  handleParentItemClick = (parentItem) => {
    Analytics.sendClickEvent("parent-item-clicked");
    Analytics.sendClickEvent("parent-item-clicked: " + parentItem.text);
    console.log('click parentItem', parentItem);
    this.props.onParentItemClick(parentItem);
    let showRelatedItems = true;
    if ((parentItem.text === "Ceiling" &&
      (document.kvConfig.visualizerType === "Bathroom" || document.kvConfig.visualizerType === "BV"))
      || parentItem.text === "Floor" || parentItem.text === "Window" || parentItem.text === "Toilet") {
      showRelatedItems = false;
      this.handleToggleDropdown();
    }

    this.setState({
      showRelatedItems,
      translateId: parentItem.part.translateId
    });
    if (parentItem.text === "Floor") {
      $('html, body').animate({scrollTop: document.body.scrollHeight}, 800);
    } else if (parentItem.text === "Ceiling") {
      $('html, body').animate({scrollTop: 0}, 800);
    }
  };

  handleBackClick = () => {
    this.setState({
      showRelatedItems: false,
      translateId: this.props.activePart.translateId
    });
  };

  handleRelatedItemClick = (relatedItem) => {
    Analytics.sendClickEvent("related-item-clicked");
    Analytics.sendClickEvent("related-item-clicked: " + relatedItem.part.partName);
    console.log('relatedItem', relatedItem);
    this.props.onSubPartClick(relatedItem);
    this.handleToggleDropdown();
    this.setState({
      translateId: relatedItem.part.translateId
    });
    if (relatedItem.text === "Ceiling") {
      $('html, body').animate({scrollTop: 0}, 800);
    }
  };

  handleToggleDropdown = () => {
    Analytics.sendClickEvent(this.state.toggle
      ? "mobile-menu-select-dropdown-toggle-closed"
      : "mobile-menu-select-dropdown-toggle-open"
    );

    this.setState({
      toggle: !this.state.toggle
    }, () => {
      if (this.state.toggle) {
        this.setState({
          subParts: this.props.activePart.subParts(),
          showRelatedItems: this.props.activePart.partName === "Toilet" ? false : !!this.props.activeSubPart
        });
        setTimeout(() => {
          window.addEventListener('click', this.handleWrapperBlur);
        }, 0)
      } else {
        window.removeEventListener('click', this.handleWrapperBlur)
      }
    })
  };

  handleWrapperBlur = (e) => {
    if (!e.target.closest('.menu-select__dropdown-list-item')
      && !e.target.closest('.menu-select__dropdown-back') && !e.target.closest('.menu-select__dropdown')) {
      this.handleToggleDropdown();
    }
  };

  handlePrevClick = () => {
    Analytics.sendClickEvent('mobile-menu-select-previous');
    // console.log('this.state.subParts', this.props.parentItems);
    // console.log('this.state.translateId', this.state.translateId);
    // console.log('this.state.subParts', this.state.subParts);
    // console.log('this.props.activePart', this.props.activePart);
    // console.log('this.props.activeSubPart', this.props.activeSubPart);

    let prevItem = null;
    if (this.props.activeSubPart) {
      const subParts = this.props.activePart.subParts();
      const currentChildIndex = subParts.findIndex(childItem => {
        return this.props.activeSubPart.partId === childItem.part.partId
      });
      prevItem = subParts[currentChildIndex - 1];
      // console.log('currentChildIndex', currentChildIndex);
      // console.log('prevItem', prevItem);
    }
    if (prevItem) {
      this.props.onSubPartClick(prevItem);
      this.setState({
        translateId: prevItem.part.translateId
      });
    } else {
      const currentParentIndex = this.props.parentItems.findIndex(parentItem => {
        const partName = this.props.activePart.partName;
        return parentItem.text === partName
      });
      const prevParentItem = this.props.parentItems[currentParentIndex - 1];

      // console.log('currentParentIndex', currentParentIndex);
      // console.log('prevParentItem', prevParentItem);
      if (prevParentItem) {
        this.props.onParentItemClick(prevParentItem);
        const subParts = prevParentItem.part.subParts();
        const lastSubPart = subParts[subParts.length - 1];
        // console.log('lastSubPart',lastSubPart);
        if (prevParentItem.part.menuType === 1) {
          setTimeout(() => {
            this.props.onSubPartClick(lastSubPart);
            this.setState({
              translateId: lastSubPart.part.translateId,
            });
          }, 0)
        }
      }
    }

  };

  handleNextClick = () => {
    Analytics.sendClickEvent('mobile-menu-select-next');
    let nextItem = null;
    if (this.props.activeSubPart) {
      const subParts = this.props.activePart.subParts();
      const currentChildIndex = subParts.findIndex(childItem => {
        return this.props.activeSubPart.partId === childItem.part.partId
      });
      nextItem = subParts[currentChildIndex + 1];
    }
    if (nextItem) {
      this.props.onSubPartClick(nextItem);
      this.setState({
        translateId: nextItem.part.translateId
      });
    } else {
      const currentParentIndex = this.props.parentItems.findIndex(parentItem => {
        const partName = this.props.activePart.partName;
        return parentItem.text === partName
      });
      const nextParentItem = this.props.parentItems[currentParentIndex + 1];
      if (nextParentItem) {
        this.props.onParentItemClick(nextParentItem);
        const subParts = nextParentItem.part.subParts();
        const lastSubPart = subParts[0];
        if (nextParentItem.part.menuType === 1) {
          setTimeout(() => {
            this.props.onSubPartClick(lastSubPart);
            this.setState({
              translateId: lastSubPart.part.translateId,
            });
          }, 0)
        }
      }
    }
  };

  render() {

    const dropDownStyles = this.state.toggle ? { height: this.props.desktop ? 320 : window.innerHeight - 42 } : {};

    return (
      <div className="menu-footer">
        {/*<div className={"menu-footer__image menu-footer__image--"+this.state.showName.toLowerCase().replace(" ","-")}/>*/}
        <div className="menu-footer__image">
          <button className="menu-footer__button menu-footer__button--prev" onClick={this.handlePrevClick}/>
          <button className="menu-footer__button menu-footer__button--next" onClick={this.handleNextClick}/>
        </div>
        <div className={"menu-select" + (this.state.toggle ? " menu-select--opened" : "")}>
          <div className="menu-select__input" onClick={this.handleToggleDropdown}>
            <span className="menu-select__input-label"><FormattedMessage id="mobileMenu.select.sortBy"/></span>
            <span className="menu-select__input-value">
              {this.state.translateId ? <FormattedMessage id={this.state.translateId}/> : null}
            </span>
          </div>
          <div className={"menu-select__dropdown" + (this.state.showRelatedItems ? " menu-select__dropdown--submenu" : "")} style={dropDownStyles}>
            {this.state.showRelatedItems
              ? <button className="menu-select__dropdown-back" onClick={this.handleBackClick}>
                <FormattedMessage id="mobileMenu.select.back"/>
              </button>
              : null}
            <ul className="menu-select__dropdown-list">
              {this.state.showRelatedItems && this.props.activePart ? this.props.activePart.subParts(true, true).map((subPart, index) => {
                if (!subPart.part.translateId) {
                  console.info("Feature Group Translate is missing!", subPart.part.partId);
                }
                const layout = getCurrentLayout();
                if (!layout.hasNavItemsLength(subPart)) {
                  return null
                }
                return (
                  <li key={"dropdownRelated"+index}
                      data-parent={this.props.activePart.partName}
                      onClick={() => this.handleRelatedItemClick(subPart)}
                      className={"menu-select__dropdown-list-item"
                      + (this.props.activeSubPart && (this.props.activeSubPart.partName === subPart.text)
                        ? " menu-select__dropdown-list-item--active" : "")
                      + ` menu-select__dropdown-list-item--${subPart.part.partId}`}>
                    {subPart.part.translateId ? <FormattedMessage id={subPart.part.translateId}/> : null}
                  </li>
                )
              }) : this.props.parentItems.map((parentItem, index) => {
                if (!parentItem.part.translateId) {
                  console.info("Feature Parent Group translate is missing!", parentItem.text);
                }
                return (
                  <li key={"dropdown"+index}
                      onClick={() => this.handleParentItemClick(parentItem)}
                      className={"menu-select__dropdown-list-item"
                      + (this.props.activePart && (this.props.activePart.partName === parentItem.text)
                        ? " menu-select__dropdown-list-item--active" : "")
                      + ` menu-select__dropdown-list-item--${parentItem.text.toLowerCase().replace(/ /g,"_")}`}>
                    {parentItem.part.translateId ? <FormattedMessage id={parentItem.part.translateId}/> : null}
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    )
  }
}
